// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// CONSTANTS
import { PopupNotification } from '../../../models/global/popup/popup-notification.interface';

/**
 * This state is for to define global reducer state varibles.
 * For define global reducer state purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially define
 */

// -------------------------------
//  Global State
// -------------------------------
export interface GlobalState extends EntityState<any> {
  popupNotification?: PopupNotification;
  popupNotificationCallback?: PopupNotification;
  error?: any;
}

// -------------------------------
//  Global Adapter
// -------------------------------
export const globalAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Global Initial State
// -------------------------------
export const initialState: GlobalState = globalAdapter.getInitialState(
  {
    popupNotification: null,
    popupNotificationCallback: null,
    error: null,
  },
);
